import { Helmet } from 'react-helmet-async';
// @mui
import {
  Card,
 
  Stack,
 
  Button,
 
  Container,
  Typography,
 
  Grid,
  Box,
  Divider,
} from '@mui/material';
// components
import { useNavigate } from 'react-router-dom';
 
import Iconify from '../components/iconify';
 
import useGetProjectsById from '../hooks/useGetProjectsById';
import { auth } from '../firebase';
  
export default function UserPage() {
  const navigate = useNavigate()

console.log(auth.currentUser)
  const projects = useGetProjectsById(auth.currentUser?.uid)
  
 
  return (
    auth.currentUser === null ? 
    <Container>
      <Stack justifyContent={"center"} alignContent={"center"}>
        <Typography variant="h2" sx={{textAlign:"center"}}>What we help you with</Typography>
        <Typography variant="body1" sx={{textAlign:"center"}}>Experience a hassle-free way to build your dream home with us!</Typography>
      
        <Stack justifyContent={"center"} alignItems={"center"}> 
        <Button sx={{my:6}} size="large" color="success" onClick={()=>navigate("/login")} variant="contained">Get Started</Button>
        </Stack>

        <Grid container spacing={3} sx={{mt:3}}>
        
        <Grid item xs={12} md={4}>
        <Card sx={{p:4}}>
        <Box>
          <Typography variant='h5' sx={{textAlign:"center"}}>Effortless Home Building</Typography>            
          <Divider sx={{my:6}} />
          <Typography variant='body1' sx={{textAlign:"center"}}>Our platform streamlines the entire home-building journey, from land selection to construction, all in one place. Save time and simplify your path to homeownership.</Typography>
         </Box>
        </Card>
        </Grid>
      
        <Grid item xs={12} md={4}>
        <Card sx={{p:4}}>
        <Box>
          <Typography variant='h5' sx={{textAlign:"center"}}>Trusted Professionals</Typography>            
          <Divider sx={{my:6}} />
          <Typography variant='body1' sx={{textAlign:"center"}}>Discover and connect with reputable architects, builders, and designers. We've curated a network of experts with reviews and portfolios, ensuring your dream home is in good hands.</Typography>
         </Box>
        </Card>
        </Grid>
      
        <Grid item xs={12} md={4}>
        <Card sx={{p:4}}>
        <Box>
          <Typography variant='h5' sx={{textAlign:"center"}}>Budget Bliss</Typography>            
          <Divider sx={{my:6}} />
          <Typography variant='body1' sx={{textAlign:"center"}}>Take control of your finances with our cost tracking tool. Stay on budget, avoid surprises, and confidently manage your home construction expenses.</Typography>
         </Box>
        </Card>
        </Grid>

        </Grid>

      </Stack>
    </Container> :
      <>
      <Helmet>
        <title> Tracker</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cost Tracking Tool
          </Typography>
          <Button variant="contained" color='success' onClick={()=>navigate("/dashboard/newProject")} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Project
          </Button>
        </Stack>
        <Typography sx={{textAlign:"center", fontSize:18}}>Our suite of tools simplifies construction <br/>cost estimation and tracking. Get precise estimates, 
real-time expense monitoring. <br/> Collaborate efficiently and stay on budget for project success</Typography>

<Typography variant='h6' sx={{textAlign:"center", my:5}}>Key Features</Typography>
 <Grid container >
{projects?.length === 0 && <Grid container spacing={3}>
<Grid item xs={12} md={4}> 
<Card sx={{p:3, height:"100%"}}>
<Typography sx={{fontWeight:"bold"}}>Accurate Cost Estimations:</Typography>
  <Typography>
 Our tools provide precise estimates for your construction project, allowing you to plan your budget with confidence.<br/><br/>
</Typography>
</Card>
</Grid>

<Grid item xs={12} md={4} > 
<Card sx={{p:3, height:"100%"}}>
<Typography sx={{fontWeight:"bold"}}> Comprehensive Cost Breakdown:</Typography> Gain insight into every cost component, including materials, labor, permits, and more. Get a holistic view of your expenses to make informed decisions.<br/><br/>
</Card></Grid>

<Grid item xs={12} md={4}> 
<Card sx={{p:3, height:"100%"}}>
<Typography sx={{fontWeight:"bold"}}>Real-time Expense Tracking:</Typography> Monitor your project's financial health in real-time. Stay in control of your budget and avoid unexpected overruns.<br/><br/>
</Card></Grid>

<Grid item xs={12} md={4}> 
<Card sx={{p:3, height:"100%"}}>
<Typography sx={{fontWeight:"bold"}}>Customizable Categories:</Typography> Tailor the cost tracking to your project's unique needs. Create and customize categories for expenses to match your project's specifics.<br/><br/>
</Card></Grid>

<Grid item xs={12} md={4}> 
<Card sx={{p:3, height:"100%"}}>
<Typography sx={{fontWeight:"bold"}}>Document Upload:</Typography> Easily attach invoices, receipts, and documents to each expense entry for clear documentation and hassle-free audits 
</Card></Grid>

</Grid>}

    {projects?.map((p, index)=>(
      <Grid item sx={12} md={6} key={index}>
          <Card sx={{p:3}} onClick={()=>navigate("/dashboard/viewProject/", {state : p})}>
            <Box>
              <Typography variant="h6">{p.name}</Typography>
              <Typography>{p.description}</Typography>
            </Box>
          </Card>
      </Grid>
    )
    )}
 </Grid>
      </Container>
    </>
  );
}
